import { colors } from '@packages/core/styles';
import { Button, Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';

import { ssm5TextStyles } from '../ssm5.styles';

/** Props for {@link Ssm5PageHeader}. */
export type Ssm5PageHeaderProps = {
    /** Label of the header action. */
    actionLabel: string;
    /** Called when the action is pressed. */
    onActionPress: () => void;
    /** The page title. */
    title: string;
};

const useStyles = createUseStyles({
    action: {
        '&:hover [dir]': {
            textDecoration: 'underline',
        },
    },
    header: {
        alignItems: 'center',
        backgroundColor: colors.white,
        borderBottom: `1px solid ${colors.grayThree}`,
        display: 'flex',
        gap: 16,
        justifyContent: 'space-between',
        minHeight: 72,
        padding: '16px 24px 15px',
    },
});

/**
 * Title row of the SSM5 page with a single text action on the right.
 *
 * @param props - {@link Ssm5PageHeaderProps}
 * @returns the page header
 */
export function Ssm5PageHeader({ actionLabel, onActionPress, title }: Ssm5PageHeaderProps) {
    const classes = useStyles();

    return (
        <header className={classes.header}>
            <Typography style={ssm5TextStyles.pageTitle} variant="h2">
                {title}
            </Typography>
            <div className={classes.action}>
                <Button onPress={onActionPress} title={actionLabel} variant="link-blue" />
            </div>
        </header>
    );
}
